import AOS from 'aos';
import lottie from 'lottie-web';
import { qs, qsa } from '@/utils/dom';
import { isInViewport } from '@/utils/common';
import { FormSelect } from '@/components/form/elements';
import { FormContact } from '@/components/form/form-contact';
import { Anchor } from '@/components/anchor';
import { Sticky } from '@/components/sticky';
import ModalContact from '@/components/modal-contact';
import 'aos/dist/aos.css';
const MinHeight = {
    init: () => {
        const minHeights = qsa('.min-h-screen');
        if (minHeights.length === 0)
            return;
        MinHeight.loop(minHeights);
        MinHeight.resize(minHeights);
    },
    resize: (elements) => {
        let prevWidth = window.innerWidth;
        window.addEventListener('resize', () => {
            if (prevWidth !== window.innerWidth) {
                MinHeight.loop(elements);
                prevWidth = window.innerWidth;
            }
        });
    },
    loop: (elements) => {
        const wh = window.innerHeight;
        elements.forEach((element) => {
            const elementHeight = element.clientHeight;
            element.style.minHeight = ``;
            if (elementHeight > wh) {
                element.style.minHeight = `${window.innerHeight}px`;
            }
        });
    }
};
const Toggler = {
    init: () => {
        const togglers = qsa('.toggler');
        if (togglers.length === 0)
            return;
        Toggler.loop(togglers);
        ;
    },
    loop: (togglers) => {
        togglers.forEach((toggler) => {
            toggler.addEventListener('click', () => {
                const { target } = toggler.dataset;
                const togglerTarget = qs(target);
                Toggler.dismissOthers(togglerTarget);
                togglerTarget.classList.toggle('active');
            });
        });
    },
    dismissOthers: (togglerTarget) => {
        const togglerTargets = qsa('.toggler-target');
        const id = togglerTarget.getAttribute('id');
        togglerTargets.forEach((togglerTarget) => {
            if (id !== togglerTarget.getAttribute('id')) {
                togglerTarget.classList.remove('active');
            }
        });
    }
};
const Lottie = {
    init: () => {
        const animations = [];
        const lotties = qsa('.lottie');
        if (lotties.length === 0)
            return;
        Lottie.loop(lotties, animations);
        Lottie.scroll(lotties, animations);
    },
    scroll: (elements, animations) => {
        let timer = null;
        window.addEventListener('scroll', () => {
            clearTimeout(timer);
            timer = setTimeout(() => {
                elements.forEach((element, index) => {
                    if (isInViewport(element)) {
                        animations[index].play();
                    }
                    else {
                        animations[index].goToAndStop(0);
                    }
                });
            }, 250);
        });
    },
    loop: (elements, animations) => {
        elements.forEach((element, index) => {
            const { animationPath } = element.dataset;
            const animation = lottie.loadAnimation({
                path: animationPath,
                container: element,
                renderer: 'svg',
                loop: false,
                autoplay: false,
            });
            if (isInViewport(element)) {
                animation.play();
            }
            animations.push(animation);
        });
    },
};
AOS.init();
window.addEventListener("resize", () => {
    AOS.refresh();
});
MinHeight.init();
Toggler.init();
Lottie.init();
ModalContact.init();
new FormSelect();
new FormContact();
new Anchor();
new Sticky();
